import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider } from "./contexts/ThemeContext";
import LoginPage from "./pages/LoginPage";
import HQDashboard from "./pages/HQDashboard";
import FranchiseeDashboard from "./pages/FranchiseeDashboard";
import FranchiseeManagement from "./pages/FranchiseeManagement";
import FinancialManagement from "./pages/FinancialManagement";
import KPIManagement from "./pages/KPIManagement";
import ComplaintManagement from "./pages/ComplaintManagement";
import TrainingManagement from "./pages/TrainingManagement";
import ProcurementManagement from "./pages/ProcurementManagement";
import AnnouncementsPage from "./pages/AnnouncementsPage";
import DocumentsPage from "./pages/DocumentsPage";
import UserManagement from "./pages/UserManagement";
import FinancialReports from "./pages/FinancialReports";
import "./App.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth Context
export const AuthContext = React.createContext(null);

function App() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user");
    
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userData));
    setToken(token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setToken(null);
    setUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-lg font-heading text-primary">Loading...</div>
      </div>
    );
  }

  // Role groups
  const HQ_ROLES = ["HQ_ADMIN", "SYSTEM_ADMIN", "REGIONAL_COORDINATOR"];
  const isHQRole = user && HQ_ROLES.includes(user.role);

  return (
    <ThemeProvider>
      <AuthContext.Provider value={{ user, token, login, logout }}>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={!user ? <LoginPage /> : <Navigate to="/" />} />
            
            {user ? (
              <>
                <Route path="/" element={
                  isHQRole ? <HQDashboard /> : <FranchiseeDashboard />
                } />
                <Route path="/franchisees" element={<FranchiseeManagement />} />
                <Route path="/financial" element={<FinancialManagement />} />
                <Route path="/financial/reports" element={<FinancialReports />} />
                <Route path="/kpi" element={<KPIManagement />} />
                <Route path="/complaints" element={<ComplaintManagement />} />
                <Route path="/training" element={<TrainingManagement />} />
                <Route path="/procurement" element={<ProcurementManagement />} />
                <Route path="/announcements" element={<AnnouncementsPage />} />
                <Route path="/documents" element={<DocumentsPage />} />
                {["HQ_ADMIN", "SYSTEM_ADMIN", "FRANCHISEE_OPERATOR"].includes(user.role) && (
                  <Route path="/users" element={<UserManagement />} />
                )}
              </>
            ) : (
              <Route path="*" element={<Navigate to="/login" />} />
            )}
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthContext.Provider>
    </ThemeProvider>
  );
}

export default App;
